package dev.lingvo.shared

import kotlinx.serialization.Serializable

/** Workspace artwork retains upload-origin context; projectSlug is empty after that project is removed. */
@Serializable
data class WorkspaceAssetDto(
    val id: String,
    val kind: DesignAssetKind,
    val format: ImageFormat,
    val width: Int,
    val height: Int,
    val byteSize: Int,
    val sha256: String,
    val imagePath: String,
    val createdBy: String,
    val createdAt: String,
    val projectSlug: String,
)

/** An explicit local identity makes a workspace image usable by the existing design renderer. */
@Serializable
data class WorkspaceAssetImportRequest(val assetId: String)
